import { useForm } from '@mantine/form';
import { Button, Group, Modal, Stack, MultiSelect } from '@mantine/core';

import type { BriefChainStore } from '../../../models/chain-store-contract.ts';

interface UpdateChainStoreContractStoresModalProps {
  opened: boolean;
  onClose: () => void;
  specifiedChainStores: BriefChainStore[];
  chainStoreData: BriefChainStore[];
  onConfirm: (formValues: UpdateChainStoreContractStoresForm) => void;
  isPending: boolean;
}

export interface UpdateChainStoreContractStoresForm {
  chainStoreIds: string[];
}

export default function UpdateChainStoreContractStoresModal({
  opened,
  onClose,
  specifiedChainStores,
  chainStoreData,
  onConfirm,
  isPending,
}: UpdateChainStoreContractStoresModalProps) {
  const chainStoreSelections = chainStoreData.map((chainStore) => {
    return {
      value: chainStore.id,
      label: chainStore.name,
    };
  });

  const form = useForm<UpdateChainStoreContractStoresForm>({
    mode: 'controlled',
    initialValues: {
      chainStoreIds: specifiedChainStores.map((chainStore) => chainStore.id),
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="編輯指定連鎖店"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack>
        <form
          onSubmit={form.onSubmit(
            (values: UpdateChainStoreContractStoresForm) => onConfirm(values),
          )}
        >
          <MultiSelect
            withAsterisk
            searchable
            label="指定場站"
            data={chainStoreSelections}
            key={form.key('chainStoreIds')}
            {...form.getInputProps('chainStoreIds')}
          ></MultiSelect>
          <Group justify="flex-end" mt="md">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400}>
              更新
            </Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  );
}
